import React from 'react';
import { AvatarProps } from './types.d';
import {
  Moods,
  AvatarSize,
} from './enums';
import { allAvatars } from './constants';

function Avatar({
  avatar,
  mood = Moods.default,
  size = AvatarSize.xl,
  className,
}: AvatarProps): JSX.Element | null {
  const Component = allAvatars?.[avatar]?.[mood];
  return Component ? (
    <Component
      size={size}
      className={className}
    />
  ) : null;
}

export default Avatar;
